(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["es-vx4-version"] && !Shopify.designMode) return;
  try {
    /* VX4-Version (26.10.2026): eigene Meldung statt Browser-Blase, Sprung zum Kasten, Sticky-Leiste ohne Auswahl abfangen.
   Die Pflicht selbst erzwingt das required-Attribut (funktioniert auch ohne dieses Skript).
   Mystery (data-es-vx-mys): Kasten je nach Modell der gewählten Variante ein-/ausblenden (hidden + disabled). */
(() => {
  if (!window.customElements || customElements.get('es-vx4-version')) return;
  const SCOPE = 'dialog, .shopify-section, product-card';

  /* Mystery-Kästen eines Formulars auf die aktuelle Variante stellen */
  const esSyncAll = (root) => {
    root.querySelectorAll('es-vx4-version[data-es-vx-mys]').forEach((box) => {
      if (typeof box.esSync === 'function') box.esSync();
    });
  };

  class EsVx4Version extends HTMLElement {
    connectedCallback() {
      if (!this._esReady) {
        this._radios = Array.from(this.querySelectorAll('input[type="radio"][data-es-vx4]'));
        this._err = this.querySelector('[data-es-vx4-err]');
        if (this._radios.length === 0) return;
        this._esReady = true;
        this._radios.forEach((radio) => {
          radio.addEventListener('invalid', (event) => {
            event.preventDefault();
            this.remind();
          });
          radio.addEventListener('change', () => this._clear());
        });
      }
      if (this.dataset.esVxMys && !this._esAc) this._esMysStart();
    }

    disconnectedCallback() {
      if (!this._esAc) return;
      this._esAc.abort();
      this._esAc = null;
    }

    /* true, wenn eine VX4-Version gewählt ist */
    picked() {
      return !this._radios || this._radios.some((radio) => radio.checked);
    }

    remind() {
      this.classList.add('es-vx4--error');
      if (this._err) this._err.hidden = false;
      const now = Date.now();
      if (this._last && now - this._last < 800) return;
      this._last = now;
      const rect = this.getBoundingClientRect();
      const inView = rect.top >= 70 && rect.bottom <= window.innerHeight - 70;
      if (!inView) this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try {
        this._radios[0].focus({ preventScroll: true });
      } catch (error) {
        /* egal */
      }
    }

    _clear() {
      this.classList.remove('es-vx4--error');
      if (this._err) this._err.hidden = true;
    }

    /* Mystery: auf Variantenwechsel im selben Bereich (Seite, Quick-Add-Fenster, Karte) reagieren */
    _esMysStart() {
      this._esAc = new AbortController();
      const run = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (target && (target.closest('es-vx4-version') || !this._esScope().contains(target))) return;
        this.esSync();
      };
      for (const name of ['variant:selected', 'variant:update', 'change']) {
        document.addEventListener(name, run, { signal: this._esAc.signal });
      }
      this.esSync();
    }

    _esScope() {
      return this.closest(SCOPE) || document;
    }

    /* true/false = gewählte Variante hat dieses Modell / nicht, null = unbekannt (Zustand bleibt) */
    _esMatch() {
      const scope = this._esScope();
      const opt = this.dataset.esVxOpt || '';
      const pickers = scope.querySelectorAll('variant-picker[data-product-id="' + (this.dataset.productId || '') + '"]');
      for (const picker of pickers) {
        if ((picker.closest(SCOPE) || document) !== scope) continue;
        const ids = [];
        picker.querySelectorAll('input:checked').forEach((input) => ids.push(input.dataset.optionValueId));
        picker.querySelectorAll('select').forEach((select) => {
          const option = select.selectedOptions ? select.selectedOptions[0] : null;
          if (option) ids.push(option.dataset.optionValueId);
        });
        const known = ids.filter(Boolean);
        if (known.length) return known.some((id) => opt.includes(',' + id + ','));
      }
      const form = this.closest('form');
      const input = form ? form.querySelector('input[name="id"]') : null;
      if (input && input.value) return (this.dataset.esVxVar || '').includes(',' + input.value + ',');
      return null;
    }

    esSync() {
      if (!this.dataset.esVxMys || !this._radios) return;
      const on = this._esMatch();
      if (on === null) return;
      this.hidden = !on;
      this._radios.forEach((radio) => {
        radio.disabled = !on;
      });
      if (!on) this._clear();
      const block = this.closest('.buy-buttons-block');
      if (!block) return;
      const active = Array.from(block.querySelectorAll('es-vx4-version')).some((box) => !box.hidden);
      block.toggleAttribute('data-es-vx4', active);
    }
  }

  customElements.define('es-vx4-version', EsVx4Version);

  /* Sticky-Kaufleiste: ohne VX4-Auswahl nicht „hinzugefügt“ animieren, sondern zum Kasten springen. */
  window.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target ? target.closest('sticky-add-to-cart .sticky-add-to-cart__button') : null;
      if (!button) return;
      const sticky = button.closest('sticky-add-to-cart');
      const productId = sticky ? sticky.dataset.productId : '';
      if (!productId) return;
      const quick = '#quick-add-modal-content, .quick-add-modal__content, .quick-add-modal';
      let box = null;
      for (const form of document.querySelectorAll('product-form-component[data-product-id="' + productId + '"]')) {
        if (form.closest(quick)) continue;
        esSyncAll(form);
        box = form.querySelector('es-vx4-version:not([hidden])');
        if (box) break;
      }
      if (!box || typeof box.picked !== 'function' || box.picked()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      box.remind();
    },
    true
  );

  /* Mystery: direkt vor dem Absenden (Klick auf In den Warenkorb) noch einmal auf die aktuelle Variante stellen. */
  window.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target ? target.closest('button, input[type="submit"]') : null;
      if (!button || button.type !== 'submit') return;
      const form = button.closest('product-form-component');
      if (form) esSyncAll(form);
    },
    true
  );
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["escooter-discovery"] && !Shopify.designMode) return;
  try {
    (() => {
  const STYLE_PARAM = 'filter.p.m.escooterskins.design_styles';
  const shuffle = (items, random = Math.random) => {
    const copy = [...items];
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
  };
  const unique = items => {
    const ids = new Set(), names = new Set();
    return items.filter(p => {
      const name = p.name.trim().toLocaleLowerCase();
      if (ids.has(p.id) || names.has(name)) return false;
      ids.add(p.id); names.add(name); return true;
    });
  };
  const rankStyles = likes => {
    const scores = new Map();
    likes.forEach(p => (p.styles || []).forEach(s => scores.set(s, (scores.get(s) || 0) + 1 / p.styles.length)));
    return [...scores.entries()].sort((a, b) => b[1] - a[1]);
  };
  const recommendations = (all, decisions, limit) => {
    const liked = decisions.filter(d => d.like).map(d => d.product);
    const weights = new Map(rankStyles(liked));
    const seen = new Set(decisions.map(d => d.product.id));
    return all.filter(p => p.available && !seen.has(p.id)).map(p => ({product:p,score:(p.styles || []).reduce((n,s) => n + (weights.get(s) || 0),0)})).filter(p => p.score > 0).sort((a,b) => b.score - a.score).slice(0,limit).map(p => p.product);
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = {shuffle, unique, rankStyles, recommendations};
  if (typeof window === 'undefined' || customElements.get('es-design-discovery')) return;
  class EsDesignDiscovery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', event => this.handleClick(event), {signal});
      this.addEventListener('keydown', event => this.handleKey(event), {signal});
      this.addEventListener('pointerdown', event => this.pointerDown(event), {signal});
      this.addEventListener('pointermove', event => this.pointerMove(event), {signal});
      this.addEventListener('pointerup', event => this.pointerUp(event), {signal});
      this.addEventListener('pointercancel', () => this.resetDrag(), {signal});
      this.addEventListener('close', () => this.onClose(), {signal,capture:true});
      window.addEventListener('popstate', () => this.syncFilterLinks(), {signal});
      this.syncFilterLinks();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.request?.abort(); this.onClose();
      clearTimeout(this.voteTimer);
    }
    get ui() { if (!this.words) this.words=JSON.parse(this.querySelector('[data-es-translations]').textContent); return this.words.ui; }
    t(key, values = {}) { let text=this.ui[key] || ''; for(const [k,v] of Object.entries(values)) text=text.replaceAll(`__${k.toUpperCase()}__`,String(v)); return text; }
    styleName(name) { this.ui; return this.words.styles[name] || name; }
    el(selector) { return this.querySelector(selector); }
    make(tag, className, text) { const el=document.createElement(tag); if(className)el.className=className; if(text!==undefined)el.textContent=text; return el; }
    consent() { try{return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;}catch{return false;} }
    track(name, product = null, extra = {}) {
      this.sessionId ||= crypto.randomUUID();
      const payload={scooter_model:this.dataset.collection,collection_id:this.dataset.collectionId,product_id:product?.id || null,categories:product?.styles || [],position:this.position!==undefined?this.position+1:null,session_id:this.sessionId || null,...extra};
      this.dispatchEvent(new CustomEvent('es-discovery:diagnostic',{bubbles:true,detail:{name,payload}}));
      if(this.dataset.preview==='true'||this.dataset.analytics!=='true'||!this.consent())return;
      try{window.Shopify?.analytics?.publish(name,payload);}catch{}
    }
    syncFilterLinks() {
      for(const link of this.querySelectorAll('[data-es-filter]')) {
        const url = location.pathname===this.dataset.url?new URL(location.href):new URL(this.dataset.url,location.origin); url.searchParams.delete('page');url.searchParams.delete('section_id');
        if(this.dataset.preview==='true')url.searchParams.set('preview_theme_id',this.dataset.themeId);
        const value=link.dataset.esFilter;
        if(value==='all'){url.searchParams.delete(STYLE_PARAM);url.searchParams.set('sort_by',this.dataset.defaultSort);}
        else if(value==='popular')url.searchParams.set('sort_by','best-selling');
        else url.searchParams.set(STYLE_PARAM,value);
        link.href=url.pathname+url.search+url.hash;
      }
    }
    async handleClick(event) {
      if(event.target===this.el('dialog')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
      const filter=event.target.closest('[data-es-filter]');
      if(filter && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button===0) {
        this.syncFilterLinks();
        const current=new URL(location.href),target=new URL(filter.href);
        if(current.pathname+current.search===target.pathname+target.search){event.preventDefault();return;}
        this.track('category_filter_click',null,{categories:[filter.dataset.esFilter],position:null});
        const native=this.closest('results-list')?.querySelector('facets-form-component');
        if(typeof native?.updateFiltersByURL==='function'){event.preventDefault();native.updateFiltersByURL(filter.href);}
        return;
      }
      const result=event.target.closest('[data-es-product-link]');
      if(result){const p=this.all?.find(p=>p.id===result.dataset.esProductLink);if(p)this.track('swipe_result_product_click',p,{position:Number(result.dataset.position),recommendation:result.dataset.recommendation==='true'});return;}
      const button=event.target.closest('[data-es-action]');if(!button)return;
      switch(button.dataset.esAction){
        case 'open':await this.open();break;
        case 'close':this.el('dialog').close();break;
        case 'restart':this.session=null;await this.start();break;
        case 'retry':this.session=null;this.all=null;await this.start();break;
        case 'like':this.vote(true);break;
        case 'dislike':this.vote(false);break;
        case 'add':await this.addToCart(button);break;
      }
    }
    async open() {
      const dialog=this.el('dialog');if(dialog.open)return;
      this.returnFocus=document.activeElement;
      this.previousOverflow=document.documentElement.style.overflow;
      dialog.showModal();document.documentElement.style.overflow='hidden';
      if(!this.session)await this.start();
      else if(!this.complete)this.showCard();
      else this.renderCompleted();
    }
    onClose() {
      if(this.previousOverflow!==undefined){document.documentElement.style.overflow=this.previousOverflow;this.previousOverflow=undefined;}
      this.returnFocus?.focus({preventScroll:true});
      this.resetDrag();
    }
    async loadProducts() {
      if(this.all)return this.all;
      this.request?.abort();this.request=new AbortController();
      let url=new URL(this.dataset.url,location.origin);url.searchParams.set('section_id','es-design-feed');url.searchParams.set('sort_by','best-selling');
      const preview=this.dataset.preview==='true'?this.dataset.themeId:null;if(preview)url.searchParams.set('preview_theme_id',preview);
      const items=[],visited=new Set();
      while(url){
        if(visited.has(url.href)||visited.size>=100)throw new Error('Pagination');visited.add(url.href);
        const response=await fetch(url,{signal:this.request.signal,credentials:'same-origin'});if(!response.ok)throw new Error('Feed');
        const html=new DOMParser().parseFromString(await response.text(),'text/html');
        const data=JSON.parse(html.querySelector('[data-es-feed]')?.textContent || '{}');
        if(data.collection!==this.dataset.collection||!Array.isArray(data.products))throw new Error('Collection');
        items.push(...data.products);
        if(data.next){url=new URL(data.next,location.origin);if(url.origin!==location.origin)throw new Error('Origin');url.searchParams.set('section_id','es-design-feed');url.searchParams.set('sort_by','best-selling');if(preview)url.searchParams.set('preview_theme_id',preview);}else url=null;
      }
      this.all=unique(items).filter(p=>p.image&&p.id&&p.name&&new URL(p.url,location.origin).origin===location.origin);
      return this.all;
    }
    async start() {
      if(this.starting)return;
      this.starting=true;this.complete=false;this.locked=true;this.position=0;this.decisions=[];this.viewed=new Set();
      this.sessionId=crypto.randomUUID();this.session={id:this.sessionId};
      this.el('[data-es-game]').hidden=false;this.el('[data-es-results]').hidden=true;this.error('');
      this.el('dialog').classList.add('is-loading');this.el('[data-es-progress]').textContent=this.t('loading');
      this.setButtons(true);
      this.track('swipe_game_open',null,{position:null,card_count:null,requested_card_count:Number(this.dataset.limit)||10});
      try{
        const items=await this.loadProducts();
        if(!this.isConnected)return;
        const available=items.filter(p=>p.available);
        this.deck=shuffle(available).slice(0,Math.min(15,Math.max(1,Number(this.dataset.limit)||10)));
        if(!this.deck.length){this.el('[data-es-game]').hidden=true;this.error(this.t('no_designs'));return;}
        this.el('progress').max=this.deck.length;
        this.showCard();
      }catch(error){if(error.name!=='AbortError'){this.error(this.t('load_error'),true);this.session=null;}}
      finally{this.starting=false;this.el('dialog')?.classList.remove('is-loading');}
    }
    error(message,retry=false) { const el=this.el('[data-es-error]');if(!el)return;el.textContent=message;el.hidden=!message;this.el('[data-es-action="retry"]').hidden=!retry; }
    setButtons(disabled){for(const b of this.querySelectorAll('[data-es-action="like"],[data-es-action="dislike"]'))b.disabled=disabled;}
    showCard() {
      if(!this.deck?.length||this.complete)return;
      if(this.position>=this.deck.length){this.finish();return;}
      const p=this.deck[this.position],card=this.el('[data-es-card]'),img=this.el('[data-es-image]');
      this.locked=true;this.setButtons(true);this.resetDrag();card.classList.remove('is-leaving');card.style.opacity='';
      this.el('[data-es-name]').textContent=p.name;this.el('[data-es-price]').textContent=p.price;
      this.el('[data-es-styles]').textContent=(p.styles||[]).map(s=>this.styleName(s)).join(' / ');
      this.el('[data-es-progress]').textContent=this.t('progress_text',{current:this.position+1,total:this.deck.length});
      this.el('[data-es-like-count]').textContent=this.t('liked_count',{count:this.decisions.filter(d=>d.like).length});
      this.el('progress').value=this.position;
      const expected=this.position;
      const ready=()=>{
        if(this.position!==expected||!this.isConnected)return;
        this.locked=false;this.setButtons(false);this.error('');
        if(this.el('dialog').open&&!this.viewed.has(p.id)){this.viewed.add(p.id);this.track('design_card_view',p);}
      };
      img.onload=ready;img.onerror=()=>{this.error(this.t('image_error'),true);this.locked=true;this.setButtons(true);};img.alt=p.name;img.src=p.image;
      if(img.complete&&img.naturalWidth>0)ready();
      const next=this.deck[this.position+1];if(next){const preload=new Image();preload.src=next.image;}
    }
    celebrateLike() {
      if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      const stage=this.el('.esd-stage'),button=this.el('[data-es-action="like"]');
      if(!stage)return;
      this.el('.esd-love-burst')?.remove();
      const burst=this.make('span','esd-love-burst');burst.setAttribute('aria-hidden','true');
      const heart=this.make('span','esd-love-heart','♥');burst.append(heart);
      for(const [x,y,delay] of [[-76,-75,0],[72,-95,35],[-100,0,65],[103,-5,20],[15,-130,80]]){
        const spark=this.make('span','esd-love-spark','♥');
        spark.style.setProperty('--heart-x',x+'px');spark.style.setProperty('--heart-y',y+'px');spark.style.setProperty('--heart-delay',delay+'ms');burst.append(spark);
      }
      stage.append(burst);
      button?.getAnimations?.().forEach(animation=>animation.cancel());
      button?.animate?.([{transform:'scale(1)'},{transform:'scale(.94)',offset:.16},{transform:'scale(1.04)',offset:.48},{transform:'scale(1)'}],{duration:420,easing:'ease-out'});
      setTimeout(()=>burst.remove(),850);
    }
    vote(like) {
      if(this.locked||this.complete||!this.el('dialog').open||!this.deck?.[this.position])return;
      this.locked=true;this.setButtons(true);
      const p=this.deck[this.position];this.decisions.push({product:p,like});this.track(like?'design_like':'design_dislike',p);
      if(like)this.celebrateLike();
      const card=this.el('[data-es-card]');card.classList.remove('is-dragging');card.classList.add('is-leaving');
      card.style.setProperty('--drag-x',`${like?450:-450}px`);card.style.setProperty('--drag-rotate',`${like?16:-16}deg`);
      this.voteTimer=setTimeout(()=>{this.position++;if(this.position>=this.deck.length)this.finish();else this.showCard();},matchMedia('(prefers-reduced-motion: reduce)').matches?0:190);
    }
    handleKey(event) {
      if(!this.el('dialog')?.open||this.complete||event.repeat||event.altKey||event.ctrlKey||event.metaKey||/INPUT|TEXTAREA|SELECT/.test(event.target.tagName))return;
      if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.vote(event.key==='ArrowRight');}
    }
    pointerDown(event) {
      const card=event.target.closest('[data-es-card]');if(!card||this.locked||event.button!==0||event.isPrimary===false)return;
      this.drag={id:event.pointerId,x:event.clientX,y:event.clientY,dx:0,horizontal:false,card};
    }
    pointerMove(event) {
      const d=this.drag;if(!d||event.pointerId!==d.id)return;
      const dx=event.clientX-d.x,dy=event.clientY-d.y;
      if(!d.horizontal){if(Math.abs(dy)>14&&Math.abs(dy)>Math.abs(dx)){this.resetDrag();return;}if(Math.abs(dx)<10)return;d.horizontal=true;d.card.setPointerCapture(event.pointerId);d.card.classList.add('is-dragging');}
      d.dx=dx;d.card.style.setProperty('--drag-x',`${dx}px`);d.card.style.setProperty('--drag-rotate',`${Math.max(-16,Math.min(16,dx/18))}deg`);
      d.card.style.setProperty('--like-opacity',String(Math.min(1,Math.max(0,dx/100))));d.card.style.setProperty('--no-opacity',String(Math.min(1,Math.max(0,-dx/100))));
    }
    pointerUp(event) {
      const d=this.drag;if(!d||event.pointerId!==d.id)return;
      const threshold=Math.min(90,d.card.clientWidth*.23);const vote=d.horizontal&&Math.abs(d.dx)>=threshold;const like=d.dx>0;
      this.resetDrag();if(vote)this.vote(like);
    }
    resetDrag() {
      const d=this.drag;if(d?.card.hasPointerCapture?.(d.id))d.card.releasePointerCapture(d.id);this.drag=null;
      const card=this.el('[data-es-card]');if(!card)return;card.classList.remove('is-dragging');for(const v of ['--drag-x','--drag-rotate','--like-opacity','--no-opacity'])card.style.removeProperty(v);
    }
    finish() {
      if(this.complete)return;this.complete=true;this.locked=true;this.el('progress').value=this.deck.length;
      const likes=this.decisions.filter(d=>d.like).map(d=>d.product);
      this.track('swipe_game_complete',null,{position:null,card_count:this.deck.length,like_count:likes.length});
      this.renderCompleted();
    }
    renderCompleted() {
      const likes=this.decisions.filter(d=>d.like).map(d=>d.product);
      this.el('[data-es-game]').hidden=true;this.el('[data-es-results]').hidden=false;this.error('');
      this.el('[data-es-summary]').textContent=likes.length?this.t('favorites_summary',{count:likes.length}):this.t('no_favorites');
      const ranked=rankStyles(likes);const match=this.el('[data-es-match]');match.hidden=likes.length<2||!ranked.length;
      match.textContent=match.hidden?'':this.t('style_match',{styles:ranked.slice(0,2).map(([s])=>this.styleName(s)).join(' / ')});
      this.renderResults(this.el('[data-es-favorites]'),likes,false);
      const target=Math.min(6,Math.max(3,Number(this.dataset.results)||4));
      const alternatives=likes.length<target?recommendations(this.all,this.decisions,Math.min(3,target-likes.length)):[];
      this.el('[data-es-alternatives]').hidden=!alternatives.length;this.renderResults(this.el('[data-es-recommendations]'),alternatives,true);
      const h=this.el('.esd-result-heading h3');h.tabIndex=-1;h.focus({preventScroll:true});this.el('dialog').scrollTop=0;
    }
    renderResults(container,products,recommendation) {
      container.replaceChildren();
      products.forEach((p,index)=>{
        const item=this.make('article','esd-result-item');
        const link=this.make('a','esd-result-image');this.productLink(link,p,index,recommendation);link.setAttribute('aria-label',p.name);
        const img=this.make('img');img.src=p.image_small;img.alt=p.name;img.width=100;img.height=100;img.loading='lazy';link.append(img);
        const info=this.make('div','esd-result-info'),title=this.make('h4'),titleLink=this.make('a','',p.name);this.productLink(titleLink,p,index,recommendation);title.append(titleLink);
        info.append(title,this.make('p','',p.price));const links=this.make('div','esd-result-links');
        const details=this.make('a','',p.variant_id?this.t('view_product'):this.t('choose_options'));this.productLink(details,p,index,recommendation);links.append(details);
        if(p.variant_id&&p.available){const add=this.make('button','',this.t('add_to_cart'));add.type='button';add.dataset.esAction='add';add.dataset.productId=p.id;add.dataset.position=String(index+1);links.append(add);}
        info.append(links);const status=this.make('p');status.dataset.esItemStatus='';status.setAttribute('role','status');info.append(status);item.append(link,info);container.append(item);
      });
    }
    productLink(link,p,index,recommendation) {const url=new URL(p.url,location.origin);if(this.dataset.preview==='true')url.searchParams.set('preview_theme_id',this.dataset.themeId);link.href=url.pathname+url.search;link.dataset.esProductLink=p.id;link.dataset.position=String(index+1);link.dataset.recommendation=String(recommendation);}
    async addToCart(button) {
      if(button.disabled)return;const p=this.all.find(p=>p.id===button.dataset.productId);if(!p?.variant_id)return;
      const label=button.textContent;button.disabled=true;button.textContent=this.t('adding');const status=button.closest('.esd-result-info').querySelector('[data-es-item-status]');status.textContent='';
      try{
        const productUrl=new URL(p.url,location.origin);productUrl.pathname+='.js';productUrl.search='';
        const check=await fetch(productUrl,{credentials:'same-origin'});if(!check.ok)throw new Error('Product');const product=await check.json();
        if(product.variants.length!==1||String(product.variants[0].id)!==p.variant_id||!product.variants[0].available||product.requires_selling_plan)throw new Error('Variant');
        const root=window.Shopify?.routes?.root || '/';
        const body={items:[{id:p.variant_id,quantity:1}]};
        body.sections=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId))].slice(0,5);
        if(this.dataset.preview!=='true'&&this.dataset.analytics==='true'&&this.consent())body.items[0].properties={_es_discovery_source:'swipe',_es_discovery_session:this.sessionId};
        const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});if(!response.ok)throw new Error('Cart');
        const added=await response.json();
        this.track('swipe_result_add_to_cart',p,{position:Number(button.dataset.position),variant_id:p.variant_id});
        status.textContent=this.t('added');button.textContent=this.t('added_button');
        const cartLink=this.make('a','',this.t('view_cart'));cartLink.href=root+'cart';button.replaceWith(cartLink);
        // Refresh the existing theme cart without risking a duplicate add if its refresh fails.
        try {
          const cartResponse=await fetch(root+'cart.js',{credentials:'same-origin'});
          if(cartResponse.ok){const cart=await cartResponse.json();
            if(document.querySelector('cart-drawer-component[auto-open]'))this.el('dialog').close();
            document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'es-design-discovery',data:{source:'es-design-discovery',itemCount:cart.item_count,productId:p.id,variantId:p.variant_id,sections:added.sections}}}));
          }
        } catch {}
      }catch{status.textContent=this.t('cart_error');button.disabled=false;button.textContent=label;}
    }
  }
  customElements.define('es-design-discovery',EsDesignDiscovery);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scripts"] && !Shopify.designMode) return;
  try {
    (() => {
  const initMotion = () => {
    if(document.documentElement.hasAttribute('data-es-motion-ready'))return;
    document.documentElement.setAttribute('data-es-motion-ready','');
    const reduced=matchMedia('(prefers-reduced-motion: reduce)'),played=new Set(),seen=new WeakSet(),active=new Set();
    const animate=(element,frames,options)=>{
      if(reduced.matches||!element?.animate)return;
      const animation=element.animate(frames,options);active.add(animation);
      animation.finished.then(()=>active.delete(animation),()=>active.delete(animation));
    };
    reduced.addEventListener('change',()=>{if(reduced.matches){active.forEach(animation=>animation.cancel());active.clear();}});
    const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
      for(const entry of entries){
        if(!entry.isIntersecting)continue;
        const button=entry.target,key=button.closest('es-design-discovery')?.dataset.collection||location.pathname;
        observer.unobserve(button);
        if(reduced.matches||played.has(key))continue;
        played.add(key);button.classList.add('es-motion-shimmer');
        setTimeout(()=>button.classList.remove('es-motion-shimmer'),1300);
      }
    },{threshold:.65}):null;
    const discover=()=>document.querySelectorAll('.esd-launch').forEach(button=>{if(!seen.has(button)){seen.add(button);observer?.observe(button);}});
    const grid=()=>document.querySelector('results-list #ResultsList')||document.querySelector('results-list .product-grid');
    const signature=()=>Array.from(document.querySelectorAll('results-list [data-product-id]'),item=>item.dataset.productId).join('|');
    const reveal=()=>animate(grid(),[{opacity:.55,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:280,easing:'ease-out'});
    let previous=signature(),pendingUntil=0,frame=0;
    document.addEventListener('filter:update',()=>{previous=signature();pendingUntil=Date.now()+8000;});
    const main=document.getElementById('MainContent');
    if(main)new MutationObserver(()=>{
      if(frame)return;
      frame=requestAnimationFrame(()=>{
        frame=0;discover();const current=signature();
        if(pendingUntil>Date.now()&&current!==previous){pendingUntil=0;reveal();}
        previous=current;
      });
    }).observe(main,{childList:true,subtree:true});
    document.addEventListener('cart:update',event=>{
      const data=event.detail?.data;
      if(!data||data.didError||!['product-form-component','es-design-discovery'].includes(data.source)||!(Number(data.itemCount)>0))return;
      requestAnimationFrame(()=>document.querySelectorAll('cart-icon').forEach(icon=>animate(icon,[{scale:'1',filter:'drop-shadow(0 0 0 transparent)'},{scale:'1.13',filter:'drop-shadow(0 0 7px #e4d98faa)',offset:.38},{scale:'1',filter:'drop-shadow(0 0 0 transparent)'}],{duration:520,easing:'ease-out'})));
    });
    discover();
    if(Array.from(new URLSearchParams(location.search).keys()).some(key=>key.startsWith('filter.')))requestAnimationFrame(reveal);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initMotion,{once:true});else initMotion();
})();
  } catch(e) { console.error(e); }
})();

})();
